export enum TourStatus {
  WELCOME = "WELCOME",
  PLAN = "PLAN",
  THIS_DOWNLOAD = "THIS_DOWNLOAD",
  REMOTE_DOWNLOAD = "REMOTE_DOWNLOAD",
  COMPLETE = "COMPLETE",
}
